<template>
    <section class="article-accordion-collapsible">
        <div :class="['position-relative', {'expand-all': !isAllExpanded(), 'collapse-all': isAllExpanded()}]">
            <a @click="toggleAll()">
                {{ isAllExpanded() ? 'Alle schließen' : 'Alle öffnen' }}
            </a>
        </div>
        <div v-for="(listItem, listItemIndex) in articleAccordionData['content_list_repeater']" :key="listItemIndex" :class="['accordion-item', `accordion-item-${listItemIndex}`, { 'active': activeAccordions.includes(listItemIndex) }]">

            <!-- Collapsible heading -->
            <h1
                class="list-headline"
                v-if="listItem['list_content_headline']"
                @click="toggleAccordion(listItemIndex)"
            >
                {{ listItem['list_content_headline'] }}
            </h1>

            <!-- Collapsible content -->
            <div :class="['accordion-content', { 'active': activeAccordions.includes(listItemIndex) }]"
                 v-if="listItem['list_content_composer_collapsible']"
                 v-for="(listContent, listContentIndex) in listItem['list_content_composer_collapsible']" :key="`${listItemIndex}-${listContentIndex}`">

                    <!-- H2 Subheadline -->
                    <h2
                        v-if="listContent['acf_fc_layout'] === 'list_content_composer_subline_h2'"
                        class="list-content-subline"
                        :data-accordion-list-item-index="listItemIndex"
                        :data-accordion-list-content-index="listContentIndex"
                    >
                        {{ listContent['list_content_subline_h2'] }}
                    </h2>

                    <!-- H3 Subheadline -->
                    <h3
                        v-if="listContent['acf_fc_layout'] === 'list_content_composer_subline_h3'"
                        class="list-content-subline"
                    >
                        {{ listContent['list_content_subline_h3'] }}
                    </h3>

                    <!-- Paragraph with image handling -->
                    <div
                        v-if="listContent['acf_fc_layout'] === 'list_content_composer_paragraph'"
                    >
                        <!-- Image below -->
                        <template v-if="listContent['list_content_copy_image'] && listContent['list_content_copy_image_position'] === 'below'">
                            <div class="list-content-copy-body" v-html="listContent['list_content_copy_body']"></div>
                            <div class="list-content-image-container">
                                <div class="list-content-image">
                                    <img :src="listContent['list_content_copy_image']" alt="">
                                </div>
                            </div>
                        </template>

                        <!-- Image left -->
                        <div
                            v-else-if="listContent['list_content_copy_image'] && listContent['list_content_copy_image_position'] === 'left'"
                            class="row"
                        >
                            <div
                                class="list-content-image-container col col-12"
                                :class="{
                                    'col-md-4': listContent['list_content_copy_image_size'] === '1/3',
                                    'col-md-6': listContent['list_content_copy_image_size'] === '1/2'
                                }"
                            >
                                <div class="list-content-image">
                                    <img :src="listContent['list_content_copy_image']" alt="">
                                </div>
                            </div>
                            <div
                                class="list-content-copy-body"
                                :class="{
                                    'col-md-8': listContent['list_content_copy_image_size'] === '1/3',
                                    'col-md-6': listContent['list_content_copy_image_size'] === '1/2'
                                }"
                                v-html="listContent['list_content_copy_body']"
                            ></div>
                        </div>

                        <!-- Image right -->
                        <div
                            v-else-if="listContent['list_content_copy_image'] && listContent['list_content_copy_image_position'] === 'right'"
                            class="row"
                        >
                            <div
                                class="list-content-copy-body"
                                :class="{
                                    'col-md-8': listContent['list_content_copy_image_size'] === '1/3',
                                    'col-md-6': listContent['list_content_copy_image_size'] === '1/2'
                                 }"
                                v-html="listContent['list_content_copy_body']"
                            ></div>
                            <div
                                class="list-content-image-container"
                                :class="{
                                    'col-md-4': listContent['list_content_copy_image_size'] === '1/3',
                                    'col-md-6': listContent['list_content_copy_image_size'] === '1/2'
                                }"
                            >
                                <div class="list-content-image">
                                    <img :src="listContent['list_content_copy_image']" alt="">
                                </div>
                            </div>
                        </div>

                        <!-- No image -->
                        <div
                            v-else
                            class="list-content-copy-body"
                            v-html="listContent['list_content_copy_body']"
                        ></div>
                    </div> <!-- Fixed closing div for paragraph handling -->

                </div> <!-- Fixed closing template tag -->

        </div>
    </section>
</template>

<script>
import cssMediaQueryHelper from '../services/cssMediaQueryHelper';
import cssUnitHelper from '../services/cssUnitHelper';

export default {
    created() {
        // Listen for popup accordion select event
        this.$root.events.$on('popupAccordionSelect', (id, listItemIndex, listContentIndex) => {
            if (id === this.articleAccordionId) {
                const element = $('[data-accordion-list-item-index="' + listItemIndex + '"][data-accordion-list-content-index="' + listContentIndex + '"]');
                if (element.length) {
                    const scrollPosition = element.offset().top - cssUnitHelper.remToPx(4.5) * cssMediaQueryHelper.watch.factor;
                    window.scrollTo(0, scrollPosition);

                    // Open the accordion containing this element
                    if (!this.activeAccordions.includes(listItemIndex)) {
                        this.activeAccordions.push(listItemIndex);
                    }
                }
            }
        });
    },
    data() {
        return {
            activeAccordions: [0], // Ensure the first item (index 0) is open initially
        };
    },
    props: {
        articleAccordionData: {
            default: () => ({}),
            type: Object,
        },
        articleAccordionId: {
            default: '',
            type: String,
        },
    },
    methods: {
        toggleAccordion(index) {
            if (this.activeAccordions.includes(index)) {
                // Remove it from the array (close it)
                this.activeAccordions = this.activeAccordions.filter(i => i !== index);
            } else {
                // Add it to the array (open it)
                this.activeAccordions.push(index);
            }
        },
        isAllExpanded() {
            return this.activeAccordions.length === this.articleAccordionData['content_list_repeater'].length;
        },
        toggleAll() {
            if (this.isAllExpanded()) {
                // Collapse all
                this.activeAccordions = [];
            } else {
                // Expand all
                this.activeAccordions = this.articleAccordionData['content_list_repeater'].map((_, index) => index);
            }
        }
    },
}
</script>

<style lang="scss">
@import '../../css/variables';

.article-accordion-collapsible {

    .collapse-all, .expand-all {
        margin: 1.5rem 0;
        text-align: right;
        a {
            cursor: pointer;
            font-size: 1.5rem;
            font-weight: bold;
            @media screen and (max-width: 767px) {
                font-size: 1.5rem * $factor-720;
            }
            @media screen and (min-width: 768px) {
                font-size: 30px;
            }
        }
    }

    .collapse-all a {
        transform: rotate(90deg);
    }

    .accordion-item {
        margin-bottom: 1rem;
        &.active .list-headline:before{
            border-width: 20px 10px 0 10px;
            border-color: #E73E51 transparent transparent transparent;
            @media screen and (min-width: 768px) {
                border-width: 40px 20px 0 20px;
            }
        }
    }

    .list-headline {
        position: relative;
        margin: 4rem 0 1rem;
        color: $color-nochvielvor-pink;
        font-size: 1.5rem;
        font-weight: bold;
        cursor: pointer;
        overflow: visible;
        @media screen and (max-width: 767px) {
            font-size: 1.5rem * $factor-720;
            margin: 2rem 0 1rem;
            padding-right: 30px;
        }
        @media screen and (min-width: 768px) {
            padding-right: 60px;
        }
        @media screen and (min-width: 1200px) {
            margin: 4rem * $factor-1200 0 1rem * $factor-1200;
            font-size: 1.5rem * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            margin: 4rem * $factor-1440 0 1rem * $factor-1440;
            font-size: 1.5rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            margin: 4rem * $factor-1920 0 1rem * $factor-1920;
            font-size: 1.5rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            margin: 4rem * $factor-2400 0 1rem * $factor-2400;
            font-size: 1.5rem * $factor-2400;
        }

        &:before {
            content: '';
            position: absolute;
            right: 0;
            top: 0;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 10px 0 10px 20px;
            border-color: transparent transparent transparent $color-nochvielvor-pink;
            transform: rotate(0deg);
            @media screen and (min-width: 768px) {
                border-width: 20px 0 20px 40px;
            }
        }
    }

    .accordion-item.accordion-item-0 .list-headline {
        margin-top: 0;
    }
    // Accordion content styling
    .accordion-content {
        padding-bottom: 1rem;
        padding-top: 1rem;
        &:not(.active) {
            display: none;
        }
        > :first-child {
            margin-top: 0;
        }
    }

    h2.list-content-subline {
        position: relative;
        margin: 1.5rem 0;
        font-size: 1.5rem;
        font-weight: bold;
        overflow: visible;

        @media screen and (max-width: 767px) {
            font-size: 1.5rem * $factor-720;
        }
        @media screen and (min-width: 768px) {
            font-size: 30px;
        }
    }

    h3.list-content-subline {
        font-size: 1rem;
        font-weight: bold;

        @media screen and (max-width: 767px) {
            font-size: 1rem * $factor-720;
        }
        @media screen and (min-width: 1200px) {
            font-size: 1rem * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            font-size: 1rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            font-size: 1rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            font-size: 1rem * $factor-2400;
        }
    }

    .list-content-copy-body {
        margin: 0 0 1rem 0;
        font-size: 1rem;
        line-height: 1.6;

        @media screen and (max-width: 767px) {
            margin: 0 0 1rem * $factor-720 0;
            font-size: 1rem * $factor-720;
        }
        @media screen and (min-width: 768px) {
            font-size: 18px;
        }

        &:last-child {
            margin-bottom: 0;
        }

        a {
            position: relative;
            padding-left: 1em;
            display: inline-block;
            color: $color-nochvielvor-pink;

            &:before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 1em;
                height: 100%;
                background-image: url(/img/ic_chevron_inline_right_e73e51.svg);
                background-position: 0 50%;
                background-repeat: no-repeat;
                background-size: 0.8em 0.8em;
            }
        }

        ol, ul {
            position: relative;
            margin: 0 0 1rem 0;
            padding: 0;
            list-style-type: none;

            @media screen and (max-width: 767px) {
                margin: 0 0 1rem * $factor-720 0;
            }
            @media screen and (min-width: 1200px) {
                margin: 0 0 1rem * $factor-1200 0;
            }
            @media screen and (min-width: 1440px) {
                margin: 0 0 1rem * $factor-1440 0;
            }
            @media screen and (min-width: 1920px) {
                margin: 0 0 1rem * $factor-1920 0;
            }
            @media screen and (min-width: 2400px) {
                margin: 0 0 1rem * $factor-2400 0;
            }
        }

        li {
            margin-left: 1.5em;
            padding: 0;
        }

        ol {
            counter-reset: list-counter;
            > li {
                counter-increment: list-counter;
                &:before {
                    content: counter(list-counter) '.';
                    position: absolute;
                    left: 0;
                }
            }
        }

        ul {
            margin-left: 0.75em;
            > li {
                &:before {
                    content: '';
                    position: absolute;
                    left: 0;
                    width: 0.5em;
                    height: 0.5em;
                    margin-top: 1ex;
                    background: $color-nochvielvor-pink;
                    transform: rotate(-45deg);
                }
            }
        }

        p {
            margin: 0 0 1rem 0;
            @media screen and (min-width: 1200px) {
                margin: 0 0 1rem * $factor-1200 0;
            }
            @media screen and (min-width: 1440px) {
                margin: 0 0 1rem * $factor-1440 0;
            }
            @media screen and (min-width: 1920px) {
                margin: 0 0 1rem * $factor-1920 0;
            }
            @media screen and (min-width: 2400px) {
                margin: 0 0 1rem * $factor-2400 0;
            }
            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .list-content-image-container {
        @media screen and (max-width: 768px) {
            margin: 1rem 0;
        }

        &:last-child {
            margin-bottom: 0;
        }

        .list-content-image {
            font-size: 1rem;

            @media (min-width: 768px) {
                position: relative;
                overflow: hidden;
            }

            img {
                width: 100%;
                height: auto;

                @media (min-width: 768px) {
                    display: block;
                }
            }
        }

        .list-content-image-copyright-text {
            opacity: 0.4;
            font-size: 10px;
            text-align: right;
            margin: 15px auto 0;
            padding-left: 15px;
            padding-right: 15px;
            -moz-user-select: none;
            -webkit-user-select: none;
            -ms-user-select: none;
            -o-user-select: none;
            user-select: none;

            @media (min-width: 768px) {
                font-size: 12px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// public/js/components/ArticleAccordionCollapsible.vue